export interface Product {
  id: number;
  name: string;
  slug: string;
  category: 'Trứng tươi' | 'Trứng bóc vỏ sẵn';
  thumbnail: string;
  description: string;
  images: string[];
  fullDescription: string;
}

export const productsData: Product[] = [
  // Trứng tươi - Trứng gà size 16 đến 23
  {
    id: 1,
    name: 'Trứng gà 16',
    slug: 'trung-ga-16',
    category: 'Trứng tươi',
    thumbnail: '/images/trung16.jpg',
    description:
      'Trứng gà size 16 tươi ngon, chất lượng cao, được thu hoạch hàng ngày. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung16.jpg', '/images/trung16.jpg'],
    fullDescription:
      'Trứng gà size 16 là sản phẩm chất lượng cao được chọn lọc kỹ càng từ các trang trại uy tín. Trứng được thu hoạch hàng ngày, đảm bảo độ tươi ngon tuyệt đối. Với quy trình kiểm tra chất lượng nghiêm ngặt, mỗi quả trứng đều đạt tiêu chuẩn vệ sinh an toàn thực phẩm. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 2,
    name: 'Trứng gà 17',
    slug: 'trung-ga-17',
    category: 'Trứng tươi',
    thumbnail: '/images/trung17.jpg',
    description:
      'Trứng gà size 17 tươi ngon, đảm bảo vệ sinh an toàn thực phẩm. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung17.jpg', '/images/trung17.jpg'],
    fullDescription:
      'Trứng gà size 17 được cung cấp từ các trang trại có chứng nhận chất lượng. Sản phẩm đảm bảo vệ sinh an toàn thực phẩm, phù hợp cho mọi gia đình. Trứng có kích thước vừa phải, chất lượng ổn định. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 3,
    name: 'Trứng gà 18',
    slug: 'trung-ga-18',
    category: 'Trứng tươi',
    thumbnail: '/images/trung18.jpg',
    description:
      'Trứng gà size 18 tươi ngon, kích thước đều, chất lượng cao. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung18.jpg', '/images/trung18.jpg'],
    fullDescription:
      'Trứng gà size 18 có kích thước đồng đều, được chọn lọc từ những con gà mái khỏe mạnh. Sản phẩm chất lượng cao, phù hợp cho các món ăn hằng ngày. Trứng được thu hoạch tươi mỗi ngày, đảm bảo độ tươi ngon tuyệt đối. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 4,
    name: 'Trứng gà 19',
    slug: 'trung-ga-19',
    category: 'Trứng tươi',
    thumbnail: '/images/trung19.jpg',
    description:
      'Trứng gà size 19 tươi ngon, chất lượng cao, được thu hoạch hàng ngày. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung19.jpg', '/images/trung19.jpg'],
    fullDescription:
      'Trứng gà size 19 là sản phẩm chất lượng cao được chọn lọc kỹ càng từ các trang trại uy tín. Trứng được thu hoạch hàng ngày, đảm bảo độ tươi ngon tuyệt đối. Với quy trình kiểm tra chất lượng nghiêm ngặt, mỗi quả trứng đều đạt tiêu chuẩn vệ sinh an toàn thực phẩm. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 5,
    name: 'Trứng gà 20',
    slug: 'trung-ga-20',
    category: 'Trứng tươi',
    thumbnail: '/images/trung20.jpg',
    description:
      'Trứng gà size 20 tươi ngon, đảm bảo vệ sinh an toàn thực phẩm. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung20.jpg', '/images/trung20.jpg'],
    fullDescription:
      'Trứng gà size 20 được cung cấp từ các trang trại có chứng nhận chất lượng. Sản phẩm đảm bảo vệ sinh an toàn thực phẩm, phù hợp cho mọi gia đình. Trứng có kích thước vừa phải, chất lượng ổn định. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 6,
    name: 'Trứng gà 21',
    slug: 'trung-ga-21',
    category: 'Trứng tươi',
    thumbnail: '/images/trung21.jpg',
    description:
      'Trứng gà size 21 tươi ngon, kích thước lớn, chất lượng cao. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung21.jpg', '/images/trung21.jpg'],
    fullDescription:
      'Trứng gà size 21 có kích thước lớn, được chọn lọc từ những con gà mái khỏe mạnh nhất. Sản phẩm chất lượng cao, phù hợp cho các dịp đặc biệt hoặc nhu cầu sử dụng hàng ngày. Trứng được thu hoạch tươi mỗi ngày, đảm bảo độ tươi ngon tuyệt đối. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 7,
    name: 'Trứng gà 22',
    slug: 'trung-ga-22',
    category: 'Trứng tươi',
    thumbnail: '/images/trung22.jpg',
    description:
      'Trứng gà size 22 tươi ngon, kích thước rất lớn, phù hợp cho nhà hàng và bếp công nghiệp. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung22.jpg', '/images/trung22.jpg'],
    fullDescription:
      'Trứng gà size 22 có kích thước lớn, được chọn lọc từ các trang trại chăn nuôi quy mô. Sản phẩm phù hợp cho các đơn vị kinh doanh ẩm thực, nhà hàng, quán ăn và gia đình có nhu cầu sử dụng nhiều. Trứng được bảo quản và vận chuyển đúng quy chuẩn, đảm bảo tươi ngon khi đến tay khách hàng. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 8,
    name: 'Trứng gà 23',
    slug: 'trung-ga-23',
    category: 'Trứng tươi',
    thumbnail: '/images/trung23.jpg',
    description:
      'Trứng gà size 23 tươi ngon, kích thước đặc biệt lớn, phù hợp cho nhu cầu chế biến đa dạng. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trung23.jpg', '/images/trung23.jpg'],
    fullDescription:
      'Trứng gà size 23 là loại trứng có kích thước lớn nhất trong dòng sản phẩm trứng gà của chúng tôi, phù hợp cho các món ăn cần nhiều lòng đỏ và lòng trắng. Sản phẩm được tuyển chọn kỹ càng và kiểm soát chất lượng nghiêm ngặt trước khi phân phối. Đảm bảo vệ sinh an toàn thực phẩm và độ tươi ngon tối đa. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  // Các loại trứng tươi khác
  {
    id: 9,
    name: 'Trứng gà ta',
    slug: 'trung-ga-ta',
    category: 'Trứng tươi',
    thumbnail: '/images/gata.jpg',
    description:
      'Trứng gà ta thả vườn, chất lượng cao, dinh dưỡng tốt. Liên hệ để biết giá tốt nhất.',
    images: ['/images/gata.jpg', '/images/gata.jpg'],
    fullDescription:
      'Trứng gà ta thả vườn được nuôi theo phương pháp truyền thống, gà được thả tự nhiên, ăn thức ăn tự nhiên. Trứng có lòng đỏ đậm đà, giàu dinh dưỡng và hương vị thơm ngon đặc trưng. Đây là sản phẩm được nhiều người ưa chuộng vì chất lượng và giá trị dinh dưỡng cao. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 10,
    name: 'Trứng vịt',
    slug: 'trung-vit',
    category: 'Trứng tươi',
    thumbnail: '/images/trungvit.jpg',
    description:
      'Trứng vịt tươi ngon, kích thước lớn, giàu dinh dưỡng. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trungvit.jpg', '/images/trungvit.jpg'],
    fullDescription:
      'Trứng vịt tươi được thu hoạch từ các trang trại uy tín, có kích thước lớn hơn trứng gà và giàu dinh dưỡng. Trứng vịt có vỏ dày, lòng đỏ đậm đà, thơm ngon và bổ dưỡng. Sản phẩm đảm bảo vệ sinh an toàn thực phẩm, phù hợp cho mọi gia đình. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 11,
    name: 'Trứng cút',
    slug: 'trung-cut',
    category: 'Trứng tươi',
    thumbnail: '/images/trungcut.jpg',
    description:
      'Trứng cút tươi ngon, kích thước nhỏ gọn, dinh dưỡng cao. Liên hệ để biết giá tốt nhất.',
    images: ['/images/trungcut.jpg', '/images/trungcut.jpg'],
    fullDescription:
      'Trứng cút tươi có kích thước nhỏ gọn nhưng giàu dinh dưỡng, đặc biệt là protein và các vitamin nhóm B. Trứng cút có vỏ mỏng, dễ bóc, lòng đỏ đậm đà và thơm ngon. Sản phẩm được nhiều người ưa chuộng vì hương vị đặc biệt và tiện lợi. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 12,
    name: 'Trứng bắc thảo',
    slug: 'trung-bac-thao',
    category: 'Trứng tươi',
    thumbnail: '/images/bacthao.jpg',
    description:
      'Trứng bắc thảo đặc biệt, hương vị độc đáo, giàu dinh dưỡng. Liên hệ để biết giá tốt nhất.',
    images: ['/images/bacthao.jpg', '/images/bacthao.jpg'],
    fullDescription:
      'Trứng bắc thảo là sản phẩm đặc biệt được chế biến theo phương pháp truyền thống, có hương vị độc đáo và giàu dinh dưỡng. Trứng có màu đen đặc trưng, lòng đỏ đậm đà, thơm ngon và bổ dưỡng. Sản phẩm được nhiều người yêu thích vì hương vị đặc biệt không thể tìm thấy ở các loại trứng khác. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  // Trứng bóc vỏ sẵn
  {
    id: 13,
    name: 'Trứng gà bóc vỏ (size 19)',
    slug: 'trung-ga-boc-vo-size-19',
    category: 'Trứng bóc vỏ sẵn',
    thumbnail:
      '/images/bocvo.jpg',
    description:
      'Trứng gà size 19 đã bóc vỏ sẵn, tiện lợi, sẵn sàng sử dụng. Liên hệ để biết giá tốt nhất.',
    images: [
      '/images/bocvo.jpg',
      '/images/bocvo.jpg',
    ],
    fullDescription:
      'Trứng gà size 19 đã bóc vỏ sẵn được chế biến từ trứng tươi, luộc chín và bóc vỏ cẩn thận. Sản phẩm tiện lợi, sẵn sàng sử dụng ngay, phù hợp cho bữa sáng nhanh, mang đi làm hoặc các bữa ăn tiện lợi. Đảm bảo vệ sinh an toàn thực phẩm, đóng gói kín. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 14,
    name: 'Trứng muối',
    slug: 'trung-muoi',
    category: 'Trứng bóc vỏ sẵn',
    thumbnail:
      '/images/trungmuoi.jpg',
    description:
      'Trứng muối truyền thống, đậm đà hương vị, bảo quản lâu. Liên hệ để biết giá tốt nhất.',
    images: [
      '/images/trungmuoi.jpg',
      '/images/trungmuoi.jpg',
    ],
    fullDescription:
      'Trứng muối được chế biến theo phương pháp truyền thống, có vị mặn đậm đà, thơm ngon đặc trưng. Sản phẩm bảo quản được lâu và tiện lợi khi sử dụng. Trứng muối thường được dùng để ăn kèm với cháo, cơm hoặc các món ăn khác. Đảm bảo vệ sinh an toàn thực phẩm. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 15,
    name: 'Trứng vịt bóc vỏ',
    slug: 'trung-vit-boc-vo',
    category: 'Trứng bóc vỏ sẵn',
    thumbnail:
    '/images/bocvo2.jpg',
    description:
      'Trứng vịt đã bóc vỏ sẵn, tiện lợi, sẵn sàng sử dụng. Liên hệ để biết giá tốt nhất.',
    images: [
      '/images/bocvo2.jpg',
      '/images/bocvo2.jpg',
    ],
    fullDescription:
      'Trứng vịt đã bóc vỏ sẵn được chế biến từ trứng vịt tươi, luộc chín và bóc vỏ cẩn thận. Sản phẩm tiện lợi, sẵn sàng sử dụng ngay, phù hợp cho những người bận rộn. Trứng vịt có kích thước lớn, lòng đỏ đậm đà, giàu dinh dưỡng. Đảm bảo vệ sinh an toàn thực phẩm, đóng gói kín. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
  {
    id: 16,
    name: 'Trứng cút bóc vỏ',
    slug: 'trung-cut-boc-vo',
    category: 'Trứng bóc vỏ sẵn',
    thumbnail:
    '/images/bocvo3.jpg',
    description:
      'Trứng cút đã bóc vỏ sẵn, tiện lợi, sẵn sàng sử dụng. Liên hệ để biết giá tốt nhất.',
    images: [
      '/images/bocvo3.jpg',
      '/images/bocvo3.jpg',
    ],
    fullDescription:
      'Trứng cút đã bóc vỏ sẵn được chế biến từ trứng cút tươi, luộc chín và bóc vỏ cẩn thận. Sản phẩm tiện lợi, sẵn sàng sử dụng ngay, phù hợp cho bữa sáng nhanh hoặc ăn vặt. Trứng cút có kích thước nhỏ gọn nhưng giàu dinh dưỡng, đặc biệt là protein. Đảm bảo vệ sinh an toàn thực phẩm, đóng gói kín. Liên hệ ngay để nhận báo giá tốt nhất.',
  },
];
